<template>
  <div class="home data-panel-home" style="min-height: 850px;">
    <Header title="提现"></Header>
    <div>
       <!-- 选择要提现的其中一个email -->
       <el-row v-if="balance !== 'NONE'" class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
         <el-col :span="10" class="select-title"><div class="left-wrap">选择提现账号</div></el-col>
         <el-col :span="14" class="padding-left-20">
         <el-select class="commit_channel" v-model="selectEmail" placeholder="请选择" @change="changeSelectEmail">
           <el-option
           v-for="item in emailList"
           :key="item"
           :label="item"
           :value="item">
           </el-option>
         </el-select>
         </el-col> 
       </el-row>
       <!-- BP余额-->
       <el-row v-if="balance !== 'NONE'" class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
         <el-col :span="10" class="select-title"><div class="left-wrap">当前BP余额</div></el-col>
         <el-col :span="14" class="right-wrap padding-left-20">{{(balance || balance === 0) ? balance : '-'}} BP</el-col>
       </el-row>
       <!-- 当前提现单价 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10"><div class="left-wrap"><div>当前提现单价</div></div></el-col>
         <el-col :span="14" class=" right-wrap padding-left-20">{{RMBPrice || '-'}} 元</el-col>
       </el-row>
       <!-- 可提现总额 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10"><div class="left-wrap">可提现总额</div></el-col>
         <el-col
           :span="14"
           class=" right-wrap padding-left-20"
         >{{canExchangeMoney || '-'}} 元</el-col>
       </el-row>
       <!-- 可兑换JD卡总额 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10">
           <div class="left-wrap">需要提现金额
           </div>
         </el-col>
         <el-col
           :span="14"
           class="padding-left-20"
         >
           <el-input v-model="exchangeMoney"></el-input>
           <span class="bonus-tips" style="display: block;width: 100%;">{{errorInfo}}</span>
         </el-col>
       </el-row>
       <!-- 兑换所需BP数量 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10">
           <div class="left-wrap" >提现所需BP数量</div>
         </el-col>
         <el-col
           :span="14"
           class="right-wrap padding-left-20"
         >{{ exchangeBXC || '-'}} BP
         </el-col>
       </el-row>
       <!-- 到账金额 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10">
           <div class="left-wrap real-money ">
             <div>到账金额</div>
             <span class="bonus-tips" style="font-size: 11px;">到账金额为代扣税点后金额</span>
           </div>
         </el-col>
         <el-col
           :span="14"
           class="right-wrap padding-left-20"
         >{{realMoney || '-'}} 元
         </el-col>
       </el-row>
       <!-- 输入手机验证码 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10" class="select-title">
           <div class="left-wrap">输入手机验证码</div>
         </el-col>
         <el-col
           :span="14"
           class="padding-left-20"
         >             
           <SendVerifyCode
             :iconType="noIcon"
             type="text"
             icon-type="emailCode"
             @verifyCodeTip="verifyCodeTip"
             v-model="inputEmailCode"
             :tel="tel"
           />
         </el-col>
       </el-row>
      <!-- 提现渠道 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10" class="select-title">
         <div class="left-wrap">提现渠道</div>
        </el-col>
        <el-col :span="14" class="padding-left-20">
        <el-select class="commit_channel" v-model="value" placeholder="请选择" @change="changeItem(value)">
          <el-option
          v-for="item in commitChannel"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled">
          </el-option>
        </el-select>
        </el-col>  
      </el-row>
       <!-- 提现渠道为支付宝时 --> 
       <el-row v-if="balance !== 'NONE'">
        <el-card class="box-card" v-if="showZFB">
          <span class="ZFB_info">支付宝姓名：{{ZFBName}}</span><br>
          <span class="ZFB_info" v-if="showAccount">支付宝账号：{{ZFBAccount}}</span>
           <span class="ZFB_info" v-else>支付宝账号：
            <span class="linkto_MyWallet">请先前往官网填写收款信息</span>
           </span>
        </el-card>
       </el-row>
     <div v-if="balance !== 'NONE'" class="buttonWrap_wechat">
       <!-- <div v-bind:class="[{ 'button-disabled': !canCommit}, 'button']" @click="sureBuyBack">确认</div> -->
       <div v-if="errorInfo" class="button-disabled button">禁 用</div>
          <div v-else @click="sureBuyBack" class="button">确认</div>

       <div class="button" style="margin-top: 10px;"><a href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95ccc89810c1da7f&redirect_uri=https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fbuybackList&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect" style="color: #fff;">提现记录</a></div>
       <!-- <div class="button" style="margin-top: 10px;">
         <a style="color: #fff;" href="http://127.0.0.1:8080/wechat/buybackList?code=0911RnGa1ou26C0EiwJa1oAdU311RnGs&state=123">提现记录</a>
        </div> -->
     </div>
     <div v-if="balance === 'NONE'" class="withdrawal-upgrade">提现升级中...</div>
   </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";
import { messageTips } from "../../utils/tips.js";
import SendVerifyCode from "@/components/Common/SendCodeNoTel.vue";
import { log } from "util";
import { baseUrl } from '../../utils/env.js';

export default {
  name: "home",
  components: {
    Header,
    SendVerifyCode,
  },
  data() {
    return {
      inputEmailCode: "",//用户输入的验证码
      exchangeMoney: "",//用户输入的需要提现的金额
      commitChannel:[
        {value:"支付宝",label:"支付宝"},
        {value:"银行卡",label:"银行卡（暂未开启）",disabled:true},
      ],
       value:"",
       showZFB:false,
       showAccount:true,
       ZFBName:"",
       ZFBAccount:"",
       noIcon: false,
       tel:'',//发送验证码的手机号
       selectEmail:'',//选择提现的email
       emailList:[],//openid下所有email列表
       type:'',
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails,
    email: (state) => state.account.email,
    balance: (state) => state.wechat.balance,
    RMBPrice: (state) => state.wechat.RMBPrice,
    discount: (state) => state.wechat.discount,
    minAmount: (state) => state.wechat.minAmount,
    maxAmount: (state) => state.wechat.maxAmount,
    // 可兑换JD卡总额
    canExchangeMoney() {
      if (this.balance && this.RMBPrice) {
        return parseInt(this.RMBPrice * this.balance);
      }
    },
    // 兑换所需要的BP数量
    exchangeBXC() {
      if (this.balance && this.RMBPrice && this.exchangeMoney) {
        return Math.ceil(this.exchangeMoney / this.RMBPrice);
      }
    },
    // 到账金额
    realMoney() {
      if (this.exchangeBXC && this.discount) {
        return Math.round(this.exchangeMoney * this.discount);
      }
    },
    errorInfo() {
      if (this.exchangeMoney) {
        if (
          this.exchangeMoney < this.minAmount ||
          this.exchangeMoney > this.maxAmount
        ) {
          return `最小提现金额为 ${this.minAmount} 元，最大提现金额为 ${this.maxAmount} 元`;
        } else if (this.exchangeMoney > this.canExchangeMoney) {
          return "余额不足";
        } else if (this.discount == 0.95 && this.exchangeMoney % 100 !== 0) {
          return "只支持以百为单位的整数提现";
        } else if (this.discount == 0.94 && this.exchangeMoney % 1000 !== 0) {
          return "只支持以百为单位的整数提现";
        } else {
          return "";
        }
      }
    },
    canCommit() {
      return (
        this.canExchangeMoney >= this.minAmount &&
        this.exchangeMoney <= this.maxAmount
      );
    },
  }),
  async created() {
    try {
      let openid = getCookie("openid") || this.$route.query.openid;
      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fwithdrawal";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;

      if (openid || code) {
        this.openId = openid;
        this.getWechatInfo({ openid, code }).then(res=>{
          this.emailList = res.emails;
        })

      } else {
        // window.location.href = "http://127.0.0.1:8080/wechat/withdrawal?code=051jslGa1e89uD0UAlGa1x2l3B4jslGS&state=123"
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions([
      "getWechatInfo", //用户email
      "getWechatTelFromEmail",//用户tel
      "getWechatBalance",//获取BP余额
      "getWechatSevenDayPrice",//获取discount等信息
      "setWechatCommitBuyBack",//wx提现
      "getBuyBackList",
      "getCollection",
    ]),

     // 提交回购
    sureBuyBack() {
       let selectEmail = this.selectEmail;
       let {
         inputEmailCode, //验证码
         canExchangeMoney, //可提现总额
         canCommit,
         exchangeMoney,//需要提现金额
         ZFBAccount,
         ZFBName,
         realMoney,//到账金额
         RMBPrice,
         discount,
         exchangeBXC,
         user_name,
       } = this;

       //判断是否选择提现账号
       if(!this.selectEmail){
         Message({
           message:"请选择要提现的账号",
           type:"error",
         })
         return false;
       }
      // 判断是否填写收款信息
      this.getCollection({ selectEmail }).then((res)=>{
       if(!res.data.ZFBAccount || !res.data.user_name){
         Message({
           message:"请先前往官网填写收款信息",
           type:"error",
         })
       }else{
         if (!exchangeMoney ||
           isNaN(exchangeMoney) ||
           Number(exchangeMoney) > Number(canExchangeMoney)) {
           Message.error('回购数量错误');
         } else if (!inputEmailCode) {
           Message.error('缺少手机验证码');
         } else if(!this.value){
           Message({
             message:"请选择提现渠道",
             type:"error",
           })
         } else {
           // this.$confirm(
           //   `兑换价值 ${exchangeMoney} 元的JD卡总额，收款到账金额为 ${realMoney}(支付宝账号: ${ZFBAccount}, 支付宝姓名: ${user_name})`,
           //   {
           //     confirmButtonText: '确认',
           //     cancelButtonText: '取消',
           //   }
           // )
           this.$confirm(`需要提现金额为 ${exchangeMoney} 元，收款到账金额为 ${realMoney}元 (支付宝账号: ${res.data.ZFBAccount}, 支付宝姓名: ${res.data.user_name})`, '提示', {
             customClass: 'message-logout'
           }).then(() => {
             let selectEmail = this.selectEmail;
             this.setWechatCommitBuyBack({
               selectEmail,//选择的邮箱
               RMBPrice,
               inputEmailCode,
               canExchangeMoney,
               canCommit,
               exchangeMoney,
               ZFBAccount,
               ZFBName,
               realMoney,
               discount,
               exchangeBXC,
             }).then((res) => {
               if (res.code === 200) {
                 Message({
                   type: "success",
                   message: "提交回购成功，会在 5 个工作日直接转账至填写的支付宝账号",
                 });
                 this.getBuyBackList();
               } else {
                 Message({
                   type: "error",
                   message: res.message || "network error",
                 });
                 this.selectEmail = '';
                 this.exchangeMoney = '';
                 this.value = '';
               }
             });
           });
         }
       }
     })
   },
    //手机验证
   verifyCodeTip(error) {
     if (error && error.message) {
       Message({
         message: error.message,
         type: "error",
       });
     }
   },
   //切换提现账号
   changeSelectEmail(val){
     let email = val;
     this.exchangeMoney = '';
     this.getWechatTelFromEmail({ email }).then(res=>{
       this.tel = res.tel;
       //  查询余额
       let id = res.id;
       this.getWechatBalance({ id,email }).then(res1=>{
         if(!res1.code || res1.data.code == 500){
           Message({
             message:res1.message || res1.data.details,
             type:'error'
           })
         }
         let type = this.type;
         this.getWechatSevenDayPrice({ type, email}).then(res2 =>{
           console.log(res2);
         })
       })
     })
     this.changeItem();
     this.value = '支付宝'
   },
   //提现渠道
   changeItem(value){
    let selectEmail = this.selectEmail;
    if(value = "支付宝"){
      this.getCollection({selectEmail}).then((res)=>{
        this.showZFB = true;
        this.ZFBName = res.data.user_name;
        this.ZFBAccount = res.data.ZFBAccount;
        if(!this.ZFBAccount){
         this.showAccount = false;
        }else{
         this.showAccount = true;
        }
      })
    }
   },
 }
};
</script>

<style scoped="scoped" lang="stylus">
  .buttonWrap_wechat{
    display:flex;
    -webkit-box-pack:center;
    justify-content:center;
    margin:30px;
    margin-bottom: 80px;
  }
  .select-title{
    line-height: 38px;
  }
  .commit_channel{
    margin:0 !important;
  }
  *{
    touch-action:none;
    touch-action:pan-y;
  }
  .el-row{
    width:100%;
    padding: 8px 15px;
  }
  .data-panel-home.home {
    height: auto !important;
  }

  .addr-status {
    margin: 40px;
    color: #909399;
  }

  .last-price-key {
    margin: 10px 0;
  }

  .commit-wrap {
    .left-wrap {
      width: 100%;
      color: #96999b;
      text-align: right;
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      margin: 10px 0;
    }
  
  .ZFB_info{
    font-size:18px;
    line-height:50px;
    color:black;
    text-align:center;
  }
	
  .item {
    padding: 18px 0;
  }
	
  .el-card__body{
    padding:20px 0;
  }
	
  .linkto_MyWallet{
    color:#f56c6c;
  }
	
  .box-card {
    width: 400px;
    margin:80px 37%;
    background-color:white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-radius:2px;
    display:flex;
  }

  .right-wrap {
    margin: 10px 0;
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }

  .right-input {
    width: 230px;
    height: 40px;
    margin: 15px 0;
  }

  .captcha-wrap {
    margin: 15px 0;
  }

  .real-money {
    line-height: 30px;
  }
}
</style>
<style>
  .message-logout {
    width: 80% !important;
  }
</style>